import React from "react";

function InvitedMember(props: { user: any, showEdit?: any }) {
  const {user, showEdit} = props;

  function formatUser() {
    return <div>
      {user.email}, <b><span className="text-capitalize">{user.scope}</span></b>
    </div>;
  }

  return (
    <li className="pb-1">
      {showEdit ?
        <a href="/#" onClick={(e) => {
          showEdit(user.id);
          e.preventDefault();
        }}>{formatUser()}</a>
        : formatUser()
      }
    </li>
  );
}

export default InvitedMember;
